<h2 mat-dialog-title>Modifica foto profilo</h2>

<mat-dialog-content>
  <div class="file-upload-container">
    <!-- Preview -->
    <div *ngIf="previewUrl" class="preview-container">
      <img [src]="previewUrl" alt="Preview" class="preview-image">
      <button
        mat-icon-button
        class="remove-btn"
        (click)="removeSelectedFile()"
        matTooltip="Rimuovi immagine"
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- File Input -->
    <div *ngIf="!previewUrl" class="upload-area">
      <input
        type="file"
        #fileInput
        (change)="onFileSelected($event)"
        accept="image/*"
        hidden>

      <!-- Azione secondaria dentro il contenuto: pillola bianca bordata nera
           2px, come i pulsanti secondari del resto dell'app. Il petrol pieno
           resta al solo "Salva" nella fascia delle azioni. -->
      <button
        mat-stroked-button
        (click)="fileInput.click()"
        class="izy-button-ghost custom-button-border">
        <mat-icon>cloud_upload</mat-icon>
        Scegli immagine
      </button>

      <p class="file-hint">Formati supportati: JPG, PNG, GIF. Dimensione massima: 5MB</p>
    </div>

    <!-- Loading Spinner -->
    <mat-spinner *ngIf="isUploading" diameter="40" class="spinner"></mat-spinner>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: pillola bianca per l'uscita neutra, petrol pieno per
       l'azione che si vuole compiere. -->
  <button
    mat-stroked-button
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    Indietro
  </button>
  <button
    mat-raised-button
    matButton="filled"
    (click)="confirm()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>edit</mat-icon>
    Salva
  </button>
</mat-dialog-actions>
